// extracted by mini-css-extract-plugin
export default {"login-view":"LoginView_login-view__YIP2D","message":"LoginView_message__Dm0Rj"};